import { FC, ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setLanguage as setAppLanguage } from '@/utils/languageSync';
import HelpModal from '@/components/HelpModal';
import LogoPL from '@/assets/images/menu/P-L.png';
import styles from './index.module.scss';

interface AuthLayoutProps {
  children: ReactNode;
}

const AuthLayout: FC<AuthLayoutProps> = ({ children }) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.startsWith('fr') ? 'FR' : 'EN';
  const [helpModalOpen, setHelpModalOpen] = useState(false);

  const handleLanguageChange = (lang: 'FR' | 'EN') => {
    setAppLanguage(lang === 'FR' ? 'fr' : 'en');
  };

  return (
    <div className={styles.authLayout}>
      {/* 背景动画层 */}
      <div className={styles.backgroundLayer}>
        <div className={`${styles.blob} ${styles.blobBlue}`} />
        <div className={`${styles.blob} ${styles.blobOrange}`} />
        <div className={`${styles.blob} ${styles.blobPurple}`} />
      </div>

      {/* Logo */}
      <div className={styles.logo}>
        <img src={LogoPL} alt="The Patch" className={styles.logoIcon} />
      </div>

      {/* 语言切换器 */}
      <div className={styles.languageSwitcher}>
        <button className={`${styles.langBtn} ${currentLang === 'FR' ? styles.active : ''}`} onClick={() => handleLanguageChange('FR')}>
          FR
        </button>
        <button className={`${styles.langBtn} ${currentLang === 'EN' ? styles.active : ''}`} onClick={() => handleLanguageChange('EN')}>
          EN
        </button>
      </div>

      {/* 内容区域 */}
      <div className={styles.contentWrapper}>{children}</div>

      {/* 帮助按钮 - 白色主题 */}
      <button className={styles.helpButton} onClick={() => setHelpModalOpen(true)} aria-label="Help" title="Help">
        <svg className={styles.helpIcon} aria-hidden="true">
          <use xlinkHref="#icon-help" />
        </svg>
      </button>

      {/* 帮助弹框 */}
      <HelpModal open={helpModalOpen} onClose={() => setHelpModalOpen(false)} />
    </div>
  );
};

export default AuthLayout;
